export * from './IPersistenceItem';
